<template>
  <div
    class="doc-to-quiz__security-tooltip"
    v-tooltip="isDocToSlideImportModal ? '' : docToQuizDisabledTooltip"
    @mouseover="showGenerateQuizFromDocTooltipAndTrack()"
    @mouseleave="generateQuizFromDocTooltipVisible = false"
  >
    <aha-icon
      name="question"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      class="text-secondary-40 ml-1 mb-0.5 cursor-pointer"
    />
    <aha-custom-tooltip
      v-if="isSecurityTooltipVisible"
      :html="generateQuizFromDocTooltip"
      class="generate-from-doc__tooltip"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import utils from '@/util.js'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'
import { IMPORT_DOCUMENT } from '@/constant/eventActions'

export default {
  props: {
    isDocToSlideImportModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      generateQuizFromDocTooltipVisible: false,
    }
  },
  computed: {
    ...mapGetters('docToSlideGenerator', ['isDocToSlideGenerating']),
    ...mapState({
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
      importStatus: (state) => state.importStatus,
    }),
    generateQuizFromDocTooltip() {
      return this.$i18nPresenter.t("This feature uses third-party AI services from OpenAI and Groq. AhaSlides does NOT send your personal information to these providers. Learn more at <a href='https://openai.com/policies/row-privacy-policy/' class='aha-custom-tooltip__link' target='_blank'>OpenAI</a>'s and <a href='https://groq.com/privacy-policy/' class='aha-custom-tooltip__link' target='_blank'>Groq</a>'s Privacy pages.")
    },
    isUploadingOrConvertingFile() {
      return this.importStatus == 2 || this.importStatus == 3
    },
    isDocToSlideCheckBoxDisabled() {
      return this.isDocToSlideGenerating || this.isUploadingOrConvertingFile
    },
    docToQuizDisabledTooltip() {
      if (!this.isDocToSlideGenerating) return null
      return this.$i18nPresenter.t('A quiz is currently generating. Please wait to use this feature.')
    },
    isSecurityTooltipVisible() {
      if (this.isDocToSlideImportModal && this.generateQuizFromDocTooltipVisible) return true
      return this.generateQuizFromDocTooltipVisible && !this.isDocToSlideCheckBoxDisabled
    },
  },
  methods: {
    showGenerateQuizFromDocTooltipAndTrack() {
      this.generateQuizFromDocTooltipVisible = true
      const eventAction = `${IMPORT_DOCUMENT} > Generate quiz from this document > Hover`
      const trackData = {
        eventAction,
        eventCategory: EVENT_CATEGORIES_BY_ROUTE_NAME[this.$route.name],
        presentationId: this.presentation.id,
        userId: this.currentUser.id,
      }
      utils.trackGA4AndMixpanel(eventAction, trackData)
    },
  },
}
</script>

<style lang="scss" scoped>
.generate-from-doc__tooltip {
  &::v-deep.aha-custom-tooltip.top {
    top: -7rem;
    left: 1%;
  }
  &.custom-tooltip {
    &::after {
      transform: translate(-75%, -4px);
      width: 350px;
      height: 100px;
      text-align: left;
      white-space: unset;
    }
  }
}

</style>
